import utils from '@utils/utils';
import styles from './index.module.scss';

const EMPTY_BG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/FolderCardEmpty.png';
const FLODER_BG = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/material-manage/floderbg.png';

const FolderCard = (props) => {
    const { item, onClick } = props;

    const previewImages = item.previewImages || [];
    const isEmpty = previewImages.length === 0;
    const firstImage = previewImages[0] || '';

    return (
        <div className={`${styles.FolderCard}`} onClick={onClick}>
            <div className={styles.imageWrap}>
                {isEmpty ? (
                    <div className={styles.emptyBg} style={{ backgroundImage: `url(${EMPTY_BG})` }} />
                ) : (
                    <div className={styles.singleImage}>
                        {firstImage && <img src={utils.getImgThumbnail(firstImage)} alt="" />}
                        <div className={styles.folderOverlay} style={{ backgroundImage: `url(${FLODER_BG})` }} />
                    </div>
                )}
            </div>
            <div className={styles.info}>
                <p className={styles.name}>{item.name}</p>
                <p className={styles.time}>{item.imageCount != null ? `${item.imageCount}个素材` : ''}</p>
            </div>
        </div>
    );
};

export default FolderCard;
